import { Injectable } from '@angular/core';
import { collection, doc, addDoc, updateDoc, query, where, getFirestore, increment, arrayUnion, arrayRemove } from 'firebase/firestore';
import { collectionData } from '@angular/fire/firestore';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Workplace } from '../model/iworkplace';
import { docData } from 'rxfire/firestore';
import { UserProfile } from '../model/iuser-profile';

@Injectable({
  providedIn: 'root'
})
export class WorkplaceService {

  private db = getFirestore();
  private workplaceRef = collection(this.db, "workplace");
  listWorkplace$ !: Observable<any>;
  currentWorkplace !: Workplace;
  workplaceInvitation$ !: Observable<any>;

  constructor(
    public authService: AuthService
  ) { }

  async saveWorkplace(workplace: Workplace){
    return await addDoc(this.workplaceRef, {...workplace});
  }

  getWorkplaceByID(workplaceUID : string):Observable<Workplace | null>{
    const docRef = doc(this.db, 'workplace', workplaceUID);
    return docData(docRef, {idField:'uid'}).pipe(
      map(data=>data ? (data as Workplace): null)
    );
  }

  getWorkplaceList():Observable<any>{
    const userUID = this.authService.userProfile?.uid;
    let ownerQuery = query(this.workplaceRef, where('ownerUID', '==', userUID))
    let partnerQuery = query(this.workplaceRef, where('listRekan', 'array-contains', userUID))

    const myWorkplace$ = collectionData(ownerQuery, {idField:'uid'})
    const myWorkplacePartner$ = collectionData(partnerQuery, {idField:'uid'})
    
    return this.listWorkplace$ = combineLatest([myWorkplace$,myWorkplacePartner$]).pipe(
      map(([owned, partnered])=> [...owned, ...partnered])
    )
  }

  setCurrentWorkplace(workplace: Workplace){
    this.currentWorkplace = workplace;
  }

  getCurrentWorkplace(){
    return this.currentWorkplace;
  }

  async updateWorkplace(workplace : Workplace){
    const docRef = doc(this.db, `workplace/${workplace.uid}`);
    return await updateDoc(docRef, {noRM: increment(1)});
  }

  async sendInvitation(workplace : Workplace, staff : UserProfile){
    const docRef = doc(this.db, `workplace/${workplace.uid}`)
    return await updateDoc(docRef, {
      listRekanDetail: arrayUnion({
        uid: staff.uid,
        displayName: staff.displayName,
        email: staff.email,
        photoURL: staff.photoURL,
        status: 'awaitApproval'
      }),
      listPendingRekan: arrayUnion(staff.uid)
    });
  }

  async removeStaff(workplace : Workplace, staff : UserProfile){
    const docRef = doc(this.db, `workplace/${workplace.uid}`);
    return await updateDoc(docRef, {
      listRekanDetail: arrayRemove({
        uid: staff.uid,
        displayName: staff.displayName,
        email: staff.email,
        photoURL: staff. photoURL,
        status: staff.status
      }),
      listRekan: arrayRemove(staff.uid)
    });
  } 

  async deleteStaffRequest(workplaceUID: string, staff : UserProfile){
    const docRef = doc(this.db, `workplace/${workplaceUID}`);
    return await updateDoc(docRef, {
      listRekanDetail: arrayRemove({
        uid: staff.uid,
        displayName: staff.displayName,
        email: staff.email,
        photoURL: staff.photoURL,
        status: staff.status
      })
    });
  } 

  async removePendingStaff(workplaceUID : string, uid : string){
    const docRef = doc(this.db, `workplace/${workplaceUID}`);
    return await updateDoc(docRef,{
      listPendingRekan: arrayRemove(uid)
    })
  }

  async updateRekanDetail(workplaceUID : string, workplace: Workplace, uid: string ){
    const docRef = doc(this.db, `workplace/${workplaceUID}`);
    return await updateDoc(docRef, {
      listRekanDetail: workplace.listRekanDetail,
      listPendingRekan: arrayRemove(uid),
      listRekan: arrayUnion(uid)
    })
  }
}
